import { createContext } from 'react';

const InitializationContext = createContext({
  firstInit: true,
  finishInitialization: () => null,
});

export default InitializationContext;
